import menorahAsset from "@/assets/menorah-official.png.asset.json";
import fullLogo from "@/assets/opt/logo.png";

type LogoProps = {
  /** Altura do logo em pixels */
  size?: number;
  /**
   * `full` mostra o lockup oficial (menorá + tipografia).
   * `mark` mostra apenas o símbolo da menorá.
   */
  variant?: "full" | "mark";
};

export function Logo({ size = 44, variant = "full" }: LogoProps) {
  if (variant === "mark") {
    return (
      <img
        src={menorahAsset.url}
        alt="Beit Tefilah Rechovot"
        // Proporção real da menorá ≈ 392x602 ≈ 0.65
        width={Math.round(size * 0.65)}
        height={size}
        decoding="async"
        fetchPriority="high"
        className="shrink-0 dark:invert"
        style={{ height: size, width: Math.round(size * 0.65) }}
      />
    );
  }

  // Proporção do lockup oficial ≈ 480x254 ≈ 1.89
  return (
    <img
      src={fullLogo}
      alt="Beit Tefilah Rechovot — Casa de Oração"
      width={Math.round(size * 1.89)}
      height={size}
      decoding="async"
      fetchPriority="high"
      className="shrink-0 dark:invert"
      // Largura reservada desde o primeiro pixel: evita o "salto" do layout
      style={{ height: size, width: Math.round(size * 1.89) }}
    />
  );
}
